<template>
  <div class="model-select">
    <a-select v-model="invoiceId" placeholder="请选择" style="max-width:400px;" @dropdownVisibleChange="onChange">
      <a-select-option v-for="item in invoiceTemplateList" :key="item.id" :value="item.id">{{ item.templateName }}
      </a-select-option>
    </a-select>
    <a @click="goInvoice">&nbsp;&nbsp;&nbsp;新建发票模板</a>
  </div>
</template>

<script>
export default {
  name: 'InvoiceSelect',
  props: {
    catalogId: [String, Number],
    proId: [String, Number],
    value: [String, Number]
  },
  data() {
    return {
      invoiceTemplateList: [],
      invoiceId: undefined
    }
  },
  watch: {
    invoiceId(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    value(val) {
      this.invoiceId = val
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getTemplateList()
    })
  },
  methods: {
    onChange() {
      this.getTemplateList()
    },
    // 获取发票模板
    getTemplateList() {
      let params = {
        limitDto: { pageNum: 1, pageSize: 1000 }
      }
      this.getHttpServices().getUserService().post('invoice/v2/getTemplateList', params).then(res => {
        this.getLogUtils().logWithTag('getTemplateList', res)
        this.invoiceTemplateList = res.data
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取产品发票模板
    getMatchTemplateId() {
      let params = {
        proCatalog: this.catalogId,
        proId: this.proId
      }
      this.getHttpServices().getUserService().post('invoice/v2/getMatchTemplateId', params).then(res => {
        this.getLogUtils().logWithTag('getMatchTemplateId', res)
        if (res && res != '' && res != 0) {
          this.invoiceId = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goInvoice() {
      let Logistics = this.$router.resolve({
        name: 'InvoiceTemplate'
      })
      window.open(Logistics.href, '_blank')
    }
  }

}
</script>
<style lang="less" scoped>

</style>